import type { CmtsHostAppConfig, CmtsResolvedRuntimeMode, CmtsRuntimeMode } from "./appConfig.js";

export function isCmtsOfflineDemo(config: Pick<CmtsHostAppConfig, "resolvedRuntimeMode">): boolean {
  return config.resolvedRuntimeMode === "OFFLINE_DEMO";
}

export function isCmtsDemoLoginAllowed(config: Pick<CmtsHostAppConfig, "appEnvironment" | "enableDemoPersonaLogin" | "resolvedRuntimeMode">): boolean {
  return config.appEnvironment !== "production" && config.enableDemoPersonaLogin && config.resolvedRuntimeMode === "OFFLINE_DEMO";
}

export function normalizeRuntimeMode(value: unknown): CmtsRuntimeMode {
  return value === "LIVE_BACKEND" || value === "OFFLINE_DEMO" || value === "AUTO" ? value : "AUTO";
}

export function runtimeModeLabel(mode: CmtsResolvedRuntimeMode): string {
  return mode === "OFFLINE_DEMO" ? "Offline Demo Mode" : "Live Backend Mode";
}
